<template>
  <div 
    class="circle-counter" 
    :style="computedStyles"
  >
    <span>{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'CircleCounter',
  props: {
    value: {
      type: String | Number,
      required: false,
      default: '0'
    },
    // Размер кружка в пикселях (передается числом, например :size="60")
    size: {
      type: Number,
      default: 50
    }
  },
  computed: {
    // Объединяем все динамические стили
    computedStyles() {
      const calculatedFontSize = Math.max(9, Math.round(this.size * 0.36));

      return {
        width: `${this.size}px`,
        height: `${this.size}px`, // гарантируем пропорции
        minWidth: `${this.size}px`,
        minHeight: `${this.size}px`,
        // backgroundColor: this.avatarColors.background,
        // color: this.avatarColors.text,
        fontSize: `${calculatedFontSize}px`,
        padding: `0 ${Math.round(this.size * 0.05)}px`
      };
    }
  }
}
</script>

<style scoped>
.circle-counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--textColor);
  color: var(--textColor);
  font-family: sans-serif;
  font-weight: bold;
  user-select: none;
  text-transform: uppercase;
  box-sizing: border-box;
  /* Буквы будут стоять чуть плотнее, помогая слову уместиться */
  letter-spacing: -0.02em; 
}

.circle-counter span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-align: center;
  font-weight: 100;
}
</style>